<script>
  import Icon from '@iconify/svelte';

  let { platform, handle = null } = $props();
</script>

<span class="inline-flex items-center gap-2">
  <Icon icon={`mdi:${platform}`} class="text-secondary-500" />
  <span class="capitalize font-medium text-secondary-800">{platform}</span>
  {#if handle}<span class="text-secondary-500">{handle}</span>{/if}
</span>
